export interface ArticleItem {
  id: string;
  slug: string;
  title: string;
  excerpt: string;
  content: string;
  coverImage: string;
  category: string;
  author: string;
  publishDate: string;
  tags: string[];
  views: number;
}

export const articles: ArticleItem[] = [
  {
    id: 'a001',
    slug: '2026-nian-zui-jia-dian-ying-tui-jian',
    title: '2026年最值得期待的十部国产电影大盘点',
    excerpt: '今年国产电影市场精彩纷呈，从科幻大片到文艺佳作，我们为你整理了2026年最不容错过的十部国产电影。',
    content: `<p>2026年的中国电影市场呈现出前所未有的繁荣景象。从年初的《流浪地球3》到暑期档的多部重磅作品，国产电影在类型多元化、制作水准和叙事深度上都有了显著提升。</p>
<h2>科幻题材持续发力</h2>
<p>《流浪地球3》以更加震撼的视觉效果和更深层的人文思考，将中国科幻电影推向了新的高度。影片在全球范围内取得了超过50亿的票房成绩，成为中国电影工业化的里程碑之作。</p>
<p>与此同时，《三体》系列电影的第一部也于今年下半年开拍，备受全球科幻迷期待。</p>
<h2>现实主义题材再创高峰</h2>
<p>《孤胆义志》以一个前特工的视角，展现了当代都市中的正义与邪恶较量，动作场面精彩，剧情紧凑，获得了观众和评论界的一致好评。</p>
<h2>动画电影百花齐放</h2>
<p>《长安三万里》之后，追光动画又推出了《白蛇：浮生》，延续了"新传说"系列的高水准制作。而《深海》导演田晓鹏的新作也备受关注。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20film%20festival%20red%20carpet%20scene%20with%20movie%20posters%2C%20glamorous%20atmosphere%2C%20warm%20golden%20lighting%2C%20entertainment%20news%20header%20style%2C%20elegant%20cinema%20aesthetic&width=1200&height=600&seq=mitao-article-001&orientation=landscape',
    category: '电影资讯',
    author: '影评人小王',
    publishDate: '2026-07-31',
    tags: ['电影', '国产电影', '推荐', '2026'],
    views: 35600,
  },
  {
    id: 'a002',
    slug: 'fan-hua-bei-hou-de-shang-hai-gu-shi',
    title: '《繁花》背后的上海故事：一个时代的记忆',
    excerpt: '王家卫导演的《繁花》不仅是一部电视剧，更是对九十年代上海的一次深情回望。本文带你走进繁花背后的真实上海故事。',
    content: `<p>《繁花》改编自金宇澄的同名小说，王家卫用他标志性的视觉风格，将九十年代上海的繁华与落寞、机遇与挑战展现得淋漓尽致。</p>
<h2>黄河路的辉煌</h2>
<p>剧中的黄河路是九十年代上海最具代表性的商业街之一。那时的黄河路霓虹闪烁，饭店林立，是多少上海人心中的"美食天堂"。</p>
<p>阿宝从一个默默无闻的年轻人成长为"宝总"，他的故事折射出那个时代无数弄潮儿的奋斗历程。</p>
<h2>上海方言与文化记忆</h2>
<p>《繁花》大量使用上海方言，这不仅是对地域文化的尊重，更是对那个年代最真实的还原。通过语言，观众能够更深入地感受到上海这座城市的独特魅力。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Vintage%201990s%20Shanghai%20street%20with%20neon%20signs%20and%20old%20buildings%2C%20nostalgic%20warm%20lighting%2C%20busy%20street%20scene%2C%20cultural%20article%20header%20style%2C%20golden%20hour%20atmosphere&width=1200&height=600&seq=mitao-article-002&orientation=landscape',
    category: '影视解析',
    author: '文化观察员',
    publishDate: '2026-07-30',
    tags: ['繁花', '上海', '王家卫', '年代剧'],
    views: 28900,
  },
  {
    id: 'a003',
    slug: 'guo-man-jue-qi-zhi-lu',
    title: '国漫崛起之路：从《大圣归来》到《三体》动画',
    excerpt: '十年间，中国动画产业经历了翻天覆地的变化。从技术到内容，国漫正在以惊人的速度成长。',
    content: `<p>2015年《大圣归来》以9.56亿票房宣告国漫新时代的到来。此后十年，国漫在技术、内容和市场规模上都实现了跨越式发展。</p>
<h2>技术突破</h2>
<p>从《白蛇：缘起》到《长安三万里》，国产动画在画面精密度、动作流畅度和场景构建上都达到了国际水准。特别是追光动画和彩条屋影业，已经成为国漫品质的标杆。</p>
<h2>内容多元化</h2>
<p>如今的国漫不再局限于神话改编，《三体·动画版》开创了科幻动画新赛道，《深海》探索了实验性动画的可能性，《斗罗大陆》系列则证明了长篇连载动画的市场潜力。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20animation%20studio%20with%20artists%20working%20on%20digital%20tablets%2C%20colorful%20character%20designs%20on%20screens%2C%20creative%20atmosphere%2C%20warm%20lighting%2C%20modern%20workspace&width=1200&height=600&seq=mitao-article-003&orientation=landscape',
    category: '行业观察',
    author: '动漫评论家',
    publishDate: '2026-07-28',
    tags: ['国漫', '动画', '产业', '发展趋势'],
    views: 21300,
  },
  {
    id: 'a004',
    slug: 'kuang-biao-xi-lie-ju-zuo-ping',
    title: '《狂飙》现象级热播背后的社会思考',
    excerpt: '《狂飙》不仅是一部精彩的电视剧，更是一面映照社会现实的镜子。从安欣到高启强，每个人物都引发了观众的深度共鸣。',
    content: `<p>《狂飙》以扫黑除恶为背景，通过二十年的时间跨度，展现了正义与邪恶的长期角力。剧中人物的复杂性和命运感，让这部作品超越了普通犯罪剧的范畴。</p>
<h2>安欣：理想主义的坚守</h2>
<p>张译饰演的安欣，是剧中正义的化身。他从意气风发的青年警察到白发苍苍的老刑警，二十年如一日地追查真相。这种坚守打动了无数观众。</p>
<h2>高启强：小人物的堕落轨迹</h2>
<p>张颂文塑造的高启强堪称教科书级别的表演。他从一个卖鱼的小商贩逐渐堕落为黑恶势力头目，其转变过程令人唏嘘，也引人深思。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20crime%20drama%20analysis%20scene%2C%20dark%20and%20light%20contrast%2C%20police%20station%20atmosphere%2C%20dramatic%20composition%2C%20film%20analysis%20header%20style%2C%20tense%20mood&width=1200&height=600&seq=mitao-article-004&orientation=landscape',
    category: '影视解析',
    author: '剧评人老李',
    publishDate: '2026-07-25',
    tags: ['狂飙', '张译', '张颂文', '犯罪剧'],
    views: 45200,
  },
  {
    id: 'a005',
    slug: 'bian-ju-shi-jiao-jie-du-qing-yu-nian',
    title: '编剧视角解读《庆余年》系列的叙事艺术',
    excerpt: '《庆余年》系列的成功不仅在于演员的精彩演绎，更在于其独特的叙事结构和深刻的价值表达。从编剧角度看这部作品的魅力所在。',
    content: `<p>《庆余年》系列改编自猫腻的同名网络小说，但在改编过程中，编剧团队对原著进行了精心重构，使得剧集在保持原著精髓的同时，更加符合影视叙事的规律。</p>
<h2>穿越叙事的巧妙运用</h2>
<p>《庆余年》的穿越设定并非简单的噱头，而是整个故事的核心驱动力。范闲作为穿越者所具备的现代思维，与他所处的古代环境形成鲜明对比，这种冲突构成了故事的主要张力。</p>
<h2>人物群像的立体塑造</h2>
<p>从范闲到庆帝，从陈萍萍到范建，每个角色都有其独特的价值观和行为逻辑，没有简单的善恶二分。这种复杂性让观众能够在不同角色身上找到共鸣。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Screenwriter%20working%20at%20desk%20with%20ancient%20Chinese%20drama%20storyboard%2C%20creative%20writing%20atmosphere%2C%20warm%20desk%20lamp%20light%2C%20professional%20article%20header%2C%20literary%20aesthetic&width=1200&height=600&seq=mitao-article-005&orientation=landscape',
    category: '影视解析',
    author: '编剧小陈',
    publishDate: '2026-07-22',
    tags: ['庆余年', '编剧', '叙事', '改编'],
    views: 19800,
  },
  {
    id: 'a006',
    slug: 'liu-mei-ti-shi-dai-ying-shi-qu-shi',
    title: '流媒体时代的影视观看趋势变革',
    excerpt: '随着5G网络普及和短视频平台崛起，人们的观影习惯正在发生深刻变化。线上视频平台如何应对这场变革？',
    content: `<p>近两年来，流媒体平台之间的竞争日趋激烈。从内容制作到用户体验，各家平台都在寻求差异化竞争之路。</p>
<h2>高清画质成为标配</h2>
<p>4K甚至8K画质已成为主流视频平台的标准配置。密桃视频等聚合平台通过整合多平台资源，为用户提供了更丰富的选择。</p>
<h2>"倍速观看"现象</h2>
<p>越来越多的观众选择以1.5倍甚至2倍速观看影视内容，这一现象反映了当代人碎片化的时间利用方式，也对内容创作提出了新的挑战。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Modern%20streaming%20service%20interface%20on%20multiple%20devices%2C%20living%20room%20with%20TV%20and%20mobile%20phone%2C%20warm%20ambient%20lighting%2C%20technology%20lifestyle%20header%2C%20cozy%20atmosphere&width=1200&height=600&seq=mitao-article-006&orientation=landscape',
    category: '行业观察',
    author: '科技观察者',
    publishDate: '2026-07-20',
    tags: ['流媒体', '观影趋势', '科技', '行业分析'],
    views: 16700,
  },
];